import { StrictMode } from 'react';

import { ProductDetail } from './ProductDetail';

const ProductDetailWrapper = (): JSX.Element => (
    <StrictMode>
        <ProductDetail />
    </StrictMode>
);

export { ProductDetailWrapper };
